import { render, staticRenderFns } from "./EligibleExpenses.vue?vue&type=template&id=08485b8c&scoped=true"
import script from "./EligibleExpenses.vue?vue&type=script&lang=ts"
export * from "./EligibleExpenses.vue?vue&type=script&lang=ts"
import style0 from "./EligibleExpenses.vue?vue&type=style&index=0&id=08485b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08485b8c",
  null
  
)

export default component.exports